import React from 'react';
import Modal from 'components/UI/Modal';
import { alert } from 'util/alert';
import "./Modal.scss";
import ModalContent from "./ModalContent";
import { confirmable } from 'react-confirm';
import locale from './locale';
import './Modal.scss';

class ModalBody extends React.Component {

  constructor(props){
    super(props)
  }

	render() {
    let { 
      title,
      icon,
      show,
      proceed,
      dismiss,
      cancel,
    } = this.props;

		return (
      <Modal 
        isShowingModal={show} // if you want to show it when component mounts, set it true
        className='QRModal'

        // allowCloseByClickingShadow={false}
        // useDefaultClosebutton={true} 
        onCloseModalClick={dismiss}
        // fixedHeight={300}
        fixedWidth={250}
        // overlayColor="#000"
        // contentHeight={300} 

        hasHeader={true}
        headerType="bold" // default, bold 
        headerTitle={title} 
        headerIcon={icon} // class for icon tag
        // headerClassName=""
        // headerCustomContent={}

        hasFooter={true}
        footerType="bold" // grey, transparent, bold
        // footerClassName=""
        // footerCustomContent={}
      >
        <ModalContent {...this.props} />
      </Modal>
    );
  }
}

export default confirmable(ModalBody);



// WEBPACK FOOTER //
// ./src/template/Modals/QrCode/ModalBody.js